
import { Mail } from "lucide-react";

const ContactFooter = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:info@7.all.com";
  };

  return (
    <button 
      onClick={handleEmailClick} 
      className="flex items-center gap-2 text-xs text-muted-foreground hover:text-primary transition-colors"
    >
      <Mail size={14} />
      <span>info@7.all.com</span>
    </button>
  );
};

export default ContactFooter;
